import ReactEChartsCore from 'echarts-for-react/lib/core';
import { ChartContainer } from '../../analytics/shared/ChartContainer';
import { EmptyState } from '../../analytics/shared/EmptyState';
import { echarts } from '../../analytics/shared/echarts-config';
import { buildHorizontalBarOptions } from '../../analytics/shared/chart-option-builders';
import type { EngagementMetricsSpecialty } from '../../../types/engagement-metrics.types';

type TopSpecialtiesBreakdownProps = {
  topSpecialties: EngagementMetricsSpecialty[];
};

const buildSpecialtyOptions = (data: EngagementMetricsSpecialty[]) =>
  buildHorizontalBarOptions(
    data.map((item) => ({ label: item.specialtyName, count: item.count })),
    130,
    '#3a8f93',
  );

export const TopSpecialtiesBreakdown = ({ topSpecialties }: TopSpecialtiesBreakdownProps) => (
  <ChartContainer title="Top Specialties" subtitle="Selected discovery specialties">
    {topSpecialties.length > 0 ? (
      <ReactEChartsCore
        echarts={echarts}
        option={buildSpecialtyOptions(topSpecialties)}
        style={{ height: 300 }}
        notMerge
        lazyUpdate
      />
    ) : (
      <EmptyState message="No specialty breakdown data available." />
    )}
  </ChartContainer>
);
